import { render, staticRenderFns } from "./PorletGDS.vue?vue&type=template&id=169c56aa"
import script from "./PorletGDS.vue?vue&type=script&lang=js"
export * from "./PorletGDS.vue?vue&type=script&lang=js"
import style0 from "./PorletGDS.vue?vue&type=style&index=0&id=169c56aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports